import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  fees: {
    '& div:last-child': {
      paddingBottom: '0'
    }
  },
  feeRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  field: {
    width: '120px',
    marginLeft: '10px'
  },
  feeType: {
    flexGrow: '1',
    paddingLeft: '10px'
  },
  currencyToggler: {
    '& .MuiToggleButton-root': {
      fontFamily: palette.fontFamilies.source,
      fontSize: '18px'
    }
  }
});
export default useStyles;